import styled from 'styled-components';

import { ReactComponent as ArrowLeft } from '../../../assets/images/blueTheme/arrowLeft.svg';

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: InspireTWDC;
`;

export const Breadcrumb = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: ${({ theme: { spacers } }): string => `${spacers!.spacer02} 0`};
`;

export const ArrowLeftWrapper = styled(ArrowLeft)`
  width: 17px;
  height: 17px;
  margin-right: ${({ theme: { spacers } }): string => `${spacers!.spacer01}`};
`;

export const BreadcrumbText = styled.span`
  font-size: 14px;
  color: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
`;
